/** ! WARNING: DO NOT EDIT ! **
  This file is generated by graphql codegen.
  Make changes to *.graphql documents, not this file
**/
import type * as _Types from '_gql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetFinancialDetails_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo = { readonly __typename: 'CreditApplicationFinanceInfo', readonly desiredCredit: any | null, readonly expectedSpend: any | null };

export type GetFinancialDetails_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_accountingSoftware_CreditApplicationAccountingSoftware = { readonly __typename: 'CreditApplicationAccountingSoftware', readonly accountingSoftwareKey: string | null };

export type GetFinancialDetails_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo = { readonly __typename: 'CreditApplicationBusinessInfo', readonly annualRevenue: any | null, readonly accountingSoftware: GetFinancialDetails_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo_accountingSoftware_CreditApplicationAccountingSoftware | null };

export type GetFinancialDetails_creditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson = { readonly __typename: 'CreditApplicationPerson', readonly id: string | null, readonly firstName: string | null, readonly lastName: string | null, readonly email: string | null };

export type GetFinancialDetails_creditApplication_CreditApplication = { readonly __typename: 'CreditApplication', readonly salesforceCreditId: string, readonly fetchedAt: any | null, readonly billingCycle: _Types.BillingCycle | null, readonly hasOutsourcedAccountant: boolean | null, readonly financeInfo: GetFinancialDetails_creditApplication_CreditApplication_financeInfo_CreditApplicationFinanceInfo | null, readonly businessInfo: GetFinancialDetails_creditApplication_CreditApplication_businessInfo_CreditApplicationBusinessInfo | null, readonly outsourcedAccountant: GetFinancialDetails_creditApplication_CreditApplication_outsourcedAccountant_CreditApplicationPerson | null };

export type GetFinancialDetails_Query = { readonly __typename: 'Query', readonly creditApplication: GetFinancialDetails_creditApplication_CreditApplication | null };


export type GetFinancialDetailsVariables = _Types.Exact<{
  creditApplicationId: _Types.Scalars['ID']['input'];
}>;


export type GetFinancialDetails = GetFinancialDetails_Query;


export const GetFinancialDetailsDocument = gql`
    query GetFinancialDetails($creditApplicationId: ID!) {
  creditApplication(creditApplicationId: $creditApplicationId) {
    salesforceCreditId
    fetchedAt
    financeInfo {
      desiredCredit
      expectedSpend
    }
    billingCycle
    businessInfo {
      annualRevenue
      accountingSoftware {
        accountingSoftwareKey
      }
    }
    hasOutsourcedAccountant
    outsourcedAccountant {
      id
      firstName
      lastName
      email
    }
  }
}
    `;

/**
 * __useGetFinancialDetails__
 *
 * To run a query within a React component, call `useGetFinancialDetails` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialDetails` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialDetails({
 *   variables: {
 *      creditApplicationId: // value for 'creditApplicationId'
 *   },
 * });
 */
export function useGetFinancialDetails(baseOptions: Apollo.QueryHookOptions<GetFinancialDetails, GetFinancialDetailsVariables> & ({ variables: GetFinancialDetailsVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFinancialDetails, GetFinancialDetailsVariables>(GetFinancialDetailsDocument, options);
      }
export function useGetFinancialDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFinancialDetails, GetFinancialDetailsVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFinancialDetails, GetFinancialDetailsVariables>(GetFinancialDetailsDocument, options);
        }
export function useGetFinancialDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFinancialDetails, GetFinancialDetailsVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFinancialDetails, GetFinancialDetailsVariables>(GetFinancialDetailsDocument, options);
        }
export type GetFinancialDetailsHookResult = ReturnType<typeof useGetFinancialDetails>;
export type GetFinancialDetailsLazyQueryHookResult = ReturnType<typeof useGetFinancialDetailsLazyQuery>;
export type GetFinancialDetailsSuspenseQueryHookResult = ReturnType<typeof useGetFinancialDetailsSuspenseQuery>;
export type GetFinancialDetailsQueryResult = Apollo.QueryResult<GetFinancialDetails, GetFinancialDetailsVariables>;